import Wix from 'Wix';
import URLSearchParams from 'url-search-params';
import wixBiEvents from './wixBiEvents.json';

export default class WixBiService {

    static biToken = Wix.Utils.getInstanceValue('biToken');

    static triggerEvent = (event_name, data) => {
        let url = '';
        if (Wix.Utils.getViewMode() === 'site') {
            url = 'https://frog.wix.com/wixlabs-ugc';
        }
        if (Wix.Utils.getViewMode() === 'editor') {
            url = 'https://frog.wix.com/wixlabs-users';
        }
        if (WixBiService.biToken && typeof (WixBiService.biToken) === 'string' && wixBiEvents[event_name]) {
            const template = `evid_${wixBiEvents[event_name].evid}_template`;
            const dataRequest = data ? { ...wixBiEvents[template], ...wixBiEvents[event_name], ...data, ...WixBiService.buildData() } :
                { ...wixBiEvents[template], ...wixBiEvents[event_name], ...WixBiService.buildData() }
            let params = new URLSearchParams();
            for (let key in dataRequest) {
                if (dataRequest.hasOwnProperty(key)) {
                    params.set(key, dataRequest[key]);
                }
            }
            const wixBIRequest = `${url}?${params}`;
            fetch(wixBIRequest);
        }
        return {};
    }

    static buildData = () => {
        let generalRequest = {
            src: '63',
            app_site_id: Wix.Utils.getInstanceId(),
            biToken: WixBiService.biToken,
            instance_id: Wix.Utils.getOrigCompId() || Wix.Utils.getCompId(),
            comp_id: '',
            app_id: '12d0391f-f7a2-9f43-153d-883f9017e252',
            uuid: Wix.Utils.getInstanceValue('uid')
        };
        console.log({generalRequest})

        if (Wix.Utils.getViewMode() === 'site') {
            generalRequest.instance_id = Wix.Utils.getInstanceId();
            generalRequest.comp_id = Wix.Utils.getOrigCompId() || Wix.Utils.getCompId() || Wix.settings.getOrigCompId();
        }
        /* else {
            // Editor.
            generalRequest.app_site_id = Wix.Utils.getInstanceId();
            generalRequest.instance_id = Wix.Utils.getOrigCompId() || Wix.Utils.getCompId() || Wix.settings.getOrigCompId();
        } */
        // generalRequest = Object.assign({}, generalRequest, data);
        return generalRequest;
    }
}



// WEBPACK FOOTER //
// ./src/utils/WixBIService.js